export enum TAB_SIZES {
  SMALL = 'sm',
  MEDIUM = 'md',
}
